export const environment = {
  production: true,
  urlBase: 'https://app.saltwaterup.com/',
  // Relative path — Apache on app.saltwaterup.com reverse-proxies
  // /apiv1/** to https://www.saltwaterup.com/apiv1/**. This means the
  // browser sees same-origin requests (no CORS preflight required) and
  // the API server sees requests coming from app.saltwaterup.com's
  // server IP rather than from end-user IPs.
  restUrlBase: '/apiv1/',
  // Same reverse-proxy pattern as restUrlBase: Apache rewrites
  // /img/fish/** to https://www.saltwaterup.com/img/fish/**. Keeps
  // image requests same-origin (cleaner for service-worker caching
  // policies) and avoids any CORS surprises.
  imageUrlBase: '/img/fish/',
  adminApiId: '541741e2-ba58-43ea-85b8-6233c7429dfd',
  adminPassword: 'x',
  anyUserPassword: 'x',
};
